export default __webpack_public_path__ + "static/media/sts-cover.11d3be70.png";